import { Row, Col } from 'react-bootstrap';
import FinancialTotalsTab from '@components/advancement/FinancialTotalsTab';
import { Loading } from '@components/atomic/atoms';
import { useQuery } from '@tanstack/react-query';
import { CompleteFinancialProgress, getCashedInProgresses, getFinancialProgresses } from '@lib/api_ts/progress';

const Financial = ({ projectId }) => {
	const { data: financialAmounts, isLoading: isFinancialLoading } = useQuery({
		queryKey: ['financialProgress', projectId],
		queryFn: () => getFinancialProgresses(projectId),
		enabled: !!projectId,
	});

	const { data: cashedInAmounts, isLoading: isCashedInLoading } = useQuery({
		queryKey: ['cashedInProgress', projectId],
		queryFn: () => getCashedInProgresses(projectId),
		enabled: !!projectId,
	});

	const completeFinancialProgresses: CompleteFinancialProgress[] = financialAmounts?.map((finAmount) => {
		const matchingCashedIn = cashedInAmounts?.find((casAmount) => casAmount.month === finAmount.month && casAmount.year === finAmount.year);
		return {
			...finAmount,
			cashedInAmount: matchingCashedIn?.cashedInAmount || 0,
		};
	});

	return (
		<>
			{isFinancialLoading || isCashedInLoading ? (
				<Loading fixedHeight="50vh" />
			) : financialAmounts.length ? (
				<Row>
					<FinancialTotalsTab financialAmounts={completeFinancialProgresses} cashedInData={cashedInAmounts} />
				</Row>
			) : (
				<Row>
					<Col className="d-flex justify-content-center align-items-center">Nessun elemento disponibile</Col>
				</Row>
			)}
		</>
	);
};
export default Financial;
